"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCache = exports.CacheContext = void 0;
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
exports.CacheContext = react_1.createContext(undefined);
var useCache = function () { return react_1.default.useContext(exports.CacheContext); };
exports.useCache = useCache;
var CacheProvider = function (_a) {
    var children = _a.children;
    var cache = react_1.useRef({});
    return (react_1.default.createElement(exports.CacheContext.Provider, { value: {
            value: cache,
            read: function (key) { return ramda_1.view(ramda_1.lensProp(key), cache.current); },
            write: function (key, value) {
                cache.current = ramda_1.set(ramda_1.lensProp(key), value, cache.current);
            },
            remove: function (key) {
                cache.current = ramda_1.set(ramda_1.lensProp(key), undefined, cache.current);
            },
        } }, children));
};
exports.default = CacheProvider;
